import React from "react";
import { Box, Flex, Text, Icon } from "@chakra-ui/react";
import { FaEnvelope, FaSms, FaPhone } from "react-icons/fa";
import { FaBell } from "react-icons/fa6";
import { CiChat1 } from "react-icons/ci";
import { PiChatCircle } from "react-icons/pi";
import { FiGlobe } from "react-icons/fi";
import { getChannelLabel } from "../../../utils/channels";

const channelConfig = {
  "SMS": {
    icon: CiChat1,
    color: "#3b82f6",
    bg: "var(--brand-tint-strong)"
  },
  "SMS Sec": {
    icon: CiChat1,
    color: "#3b82f6",
    bg: "var(--brand-tint-strong)"
  },
  "WhatsApp": {
    icon: PiChatCircle,
    color: "#10b981",
    bg: "#d1fae5"
  },
  "E-Mail": {
    icon: FaEnvelope,
    color: "#f59e0b",
    bg: "#f59e0b20"
  },
  "Voice (IVR)": {
    icon: FaPhone,
    color: "var(--brand-primary)",
    bg: "var(--brand-primary)20"
  },
  "Push Notification": {
    icon: FaBell,
    color: "#ef4444",
    bg: "#ef444420"
  },
  "In-App Notification": {
    icon: FiGlobe,
    color: "#8b5cf6",
    bg: "#8b5cf620"
  },
};

export const ChannelCard = ({ 
  channel, 
  count, 
  delivered, 
  deliveryPercent, 
  per_message, 
  customer_currency = "$", 
  buckets 
}) => {
  const config = channelConfig[channel] || {
    icon: FaSms,
    bg: "#f3f4f6",
    color: "#6b7280"
  };

  return (
    <Flex
      bg="#f1f5f980"
      p={3}
      rounded="lg"
      align="center"
      gap={4}
      mb={3}
    >
      {/* Channel Icon and Name */}
      <Flex align="center" gap={3} flex="1" minW="120px">
        <Flex
          w="40px"
          h="40px"
          rounded="lg"
          bg={config.bg}
          align="center"
          justify="center"
        >
          <Icon as={config.icon} color={config.color} boxSize={4} />
        </Flex>
        <Text fontWeight="500" fontSize={"sm"} minW="80px">{getChannelLabel(channel)}</Text>
      </Flex>

      {/* Stats Section */}
      <Flex gap={6} fontSize="sm">
        {/* Total Messages */}
        <Box textAlign="center">
          <Text fontSize="xs" color="#64748b">Total</Text>
          <Text fontWeight="600">{count.toLocaleString()}</Text>
        </Box>

        {/* Delivery Rate */}
        <Box textAlign="center">
          <Text fontSize="xs" color="#64748b">Delivered</Text>
          <Text fontWeight="600" color="#008236">
            {deliveryPercent.toFixed(1)}%
          </Text>

         <Text fontSize="xs" color="#64748b">
            {delivered.toLocaleString()}
          </Text>
        </Box>

        {/* Super Fast (<30s) */}
        <Box textAlign="center">
          <Text fontSize="xs" color="#64748b">Super Fast (&lt;30s)</Text>
          <Text fontWeight="600" color="#008236">
            {buckets.less_30_sec_percent.toFixed(1)}%
          </Text>
          <Text fontSize="xs" color="#64748b">
            {buckets.less_30_sec.toLocaleString()}
          </Text>
        </Box>

        {/* Fast (<1min) */}
        <Box textAlign="center">
          <Text fontSize="xs" color="#64748b">Fast (&lt;1min)</Text>
          <Text fontWeight="600" color="var(--brand-primary-hover)">
            {buckets.less_1_min_percent.toFixed(1)}%
          </Text>
          <Text fontSize="xs" color="#64748b">
            {buckets.less_1_min.toLocaleString()}
          </Text>
        </Box>

        {/* Delayed (<5min) */}
        <Box textAlign="center">
          <Text fontSize="xs" color="#64748b">Delayed (&lt;5min)</Text>
          <Text fontWeight="600" color="#ca3500">
            {buckets.less_5_min_percent.toFixed(1)}%
          </Text>
          <Text fontSize="xs" color="#64748b">
            {buckets.less_5_min.toLocaleString()}
          </Text>
        </Box>

        {/* Outliers (>5min) */}
        <Box textAlign="center">
          <Text fontSize="xs" color="#64748b">Outliers (&gt;5min)</Text>
          <Text fontWeight="600" color="#c10007">
            {buckets.more_5_min_percent.toFixed(1)}%
          </Text>
          <Text fontSize="xs" color="#64748b">
            {buckets.more_5_min.toLocaleString()}
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
};